/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 *
 * Google CDN, Latest jQuery
 * To use the default WordPress version of jQuery, go to lib/config.php and
 * remove or comment out: add_theme_support('jquery-cdn');
 * ======================================================================== */

import common from './common';
import inspiration from './page-template-inspiration';
import findDistributor from './page-template-find-distributor';
import contact from './page-template-contact';

($ => {
  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  const app = () => ({
    common,
    page_template_template_inspiration: inspiration,
    page_template_template_find_distributor: findDistributor,
    page_template_template_contact: contact
  });

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  const UTIL = {
    fire(func, args) {
      let fire;
      const namespace = app();
      fire = func !== '';
      fire = fire && namespace[func];

      if (fire) {
        namespace[func](args);
      }
    },

    loadEvents() {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), (i, classnm) => {
        UTIL.fire(classnm);
      });
    }
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);
})(jQuery); // Fully reference jQuery after this point.
